<!-- Regular row -->
<tr cp-row class="table-row table-body-row" [class.mod-selected]="isSelected" [class.mod-expired]="row['isDueToExpire']"
    [class.branding-accent-very-light-background]="isSelected" [ngClass]="rowClass"
    [row]="row" [columns]="columns" [selection]="selection" [hideActions]="hideActions"
    [hasSecondaryRow]="!!secondaryRow"
    [hideSelection]="hideSelection"
    [inlineActions]="inlineActions" [panel]="panel"
    (toggleSelection)="toggleSelection.emit($event)"
    (inlineAction)="inlineAction.emit($event)">
</tr>

<!-- Secondary row -->
<tr *ngIf="secondaryRow" class="table-row table-body-row mod-secondary" [class.mod-expired]="row['isDueToExpire']">
  <td class="table-column table-body-column mod-secondary" [attr.colspan]="columns.length + 2">
    <ng-container *ngTemplateOutlet="secondaryRow; context: { $implicit: row, row: row }">
    </ng-container>
  </td>
</tr>
